import type { FunctionComponent, PropsWithChildren } from 'react';
import { trackDisclaimerModalOpen } from '../../../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { useModalContext } from '../../../../../contexts/ModalContext/ModalContext';
import { DisclaimerIcon } from '../../../../../app-kit/components/DisclaimerIcon/DisclaimerIcon';

interface NearbySchoolBrick {
  title: string;
  subtitle?: string | null;
}

export const NearbySchoolsBrick: FunctionComponent<PropsWithChildren<NearbySchoolBrick>> = ({
  title,
  subtitle,
  children,
}) => {
  const { displayModal } = useModalContext();
  return (
    <ContentBrick
      title={title}
      subtitle={subtitle}
      headerChildren={
        <DisclaimerIcon
          title="Open Nearby Schools Disclaimer"
          onClick={() => {
            displayModal({ name: 'nearbySchoolsDisclaimer' });
            trackDisclaimerModalOpen({
              inPageSource: 'school_page__nearby_schools_brick___disclaimer_link',
            });
          }}
        />
      }
    >
      {children}
    </ContentBrick>
  );
};
